import { IAppEnvironmentService, KeycloakEnv } from './AppEnvironment.types';
import { AppEnvironmentApi } from './AppEnvironmentApi';
import { ApiEnvInfo } from '@oceanjs/wisa';


class AppEnvironmentServiceImpl implements IAppEnvironmentService {

  constructor() {
  }

  async getEnv(): Promise<ApiEnvInfo> {
    const result = await AppEnvironmentApi.getEnvInfo();
    if(result?.data) {
      return result.data;
    }
    throw new Error();
  }

  async getKeycloakEnv(): Promise<KeycloakEnv | null> {
    // Retrieve the information from the process.env
    const { REACT_APP_KEYCLOAK_CLIENTID: clientId } = process.env;
    if (!clientId) {
      return null;
    }

    // Acquire information from service
    const result = await AppEnvironmentApi.getEnvKeycloak();
    if (!result) {
      return null;
    }

    const { authServerUrl: url, realm } = result.data.result;

    return {
      url,
      realm,
      clientId,
      'ssl-required': 'external',
      'public-client': true,
      'enable-cors': true,
    };
  }
}

export const AppEnvironmentService = new AppEnvironmentServiceImpl();
